import { url } from '@/api'
export const operationJson = [
  {
    name: '媒体宣发',
    intro: '国家级、省市级刊例资源整合、权威媒体矩阵分发',
    img: url + '/home/operation/1.png'
  },
  {
    name: '微信公众号运营',
    intro: '精准选题策划、精品内容生产、排版优化、深度用户互动与全渠道推广',
    img: url + '/home/operation/2.png'
  },
  {
    name: '出版服务',
    intro: '纸质杂志（图书）出版与发行',
    img: url + '/home/operation/3.png'
  },
  {
    name: '广告投放',
    intro: '巨量引擎、腾讯等平台多元化投放策略搭建、数据化投放优化',
    img: url + '/home/operation/4.png'
  },
  {
    name: '采编服务',
    intro: '资深编辑团队专属内容策划、专业化内容采编与标准化输出',
    img: url + '/home/operation/5.png'
  },
  {
    name: '物料制作',
    intro: '电子杂志、定制化宣传画册、海报、桌签、单页、场景适配型线下地推物料全案输出',
    img: url + '/home/operation/6.png'
  },
  {
    name: '活动策划执行',
    intro: '全渠道活动（线上 + 线下）统筹、媒体采风全流程管控、大型活动落地执行',
    img: url + '/home/operation/7.png'
  },
  {
    name: '品牌视觉设计',
    intro: '品牌 IP 形象体系构建、动态表情包等品牌创意资产定制',
    img: url + '/home/operation/8.png'
  },

  {
    name: '平面视觉设计',
    intro: '精细化长图、海报、版式等视觉创意设计',
    img: url + '/home/operation/9.png'
  },
  {
    name: '小红书账号运营',
    intro: '定制化内容创作、网感视觉体系设计、达人资源联动与全域宣推矩阵',
    img: url + '/home/operation/10.png'
  },
  {
    name: '视频账号运营',
    intro: '抖音、视频号、快手等多平台精细化运营、内容拍摄与原创内容生产',
    img: url + '/home/operation/11.png'
  },
  {
    name: '影像类内容制作',
    intro: '活动快剪、精品宣传视频等高阶影像内容输出、照片直播（含实时修图、云端交付）、专业纪实摄影服务',
    img: url + '/home/operation/12.png'
  },

]
export const productServerJson = [
  {
    name: '文旅数字化服务',
    intro: '品牌 IP 以数字平台赋能文旅行业，提供精准的数字化综合服务，强调智能化技术提升用户体验。利用数字技术为文旅提供从内容生产到运营管理的全链条解决方案。',
  },
  {
    name: '数字孪生场景搭建',
    intro: '构建数字孪生的智慧化场景，升级园区、大厅等体验与服务的智能化效能',
  },
  {
    name: '项目管理工具',
    intro: '提效项目全流程管理，赋能业务运营与资源统筹调度',
  },
  {
    name: '内容安全检测',
    intro: '筑牢内容安全防线，覆盖政务、舆情等多维度风险管控',
  },
  {
    name: '运营工具',
    intro: '创新运营工具矩阵，助力产品推广、用户互动与增长',
  },
  {
    name: '定制化开发服务',
    intro: '提供定制数智方案，适配多场景的个性化服务需求',
  },
  {
    name: '数字界面设计',
    intro: '涵盖H5页面与UI视觉创意设计',
  },


]
export const featureTabs = [
  { 
    name: '微信公众号运营', 
    path: '/promotion/wechat-operation',
    colorname: '微信公众号',
    shortName: '运营',
    data: [
      '原创内容，深挖文化内核',
      '排版设计，提升品牌质感',
      '数据复盘，驱动运营迭代',
      '生态联动，打通视频号矩阵'
    ],
    url: '/promotion/header/1.png'
  },
  { 
    name: '小红书账号运营', 
    path: '/promotion/xiaohongshu-operation',
    colorname: '小红书账号',
    shortName: '运营',
    data: [
      '精准内容定位',
      '平台规则解析',
      '用户画像分析',
      '投放策略优化'
    ],
    url: '/promotion/header/2.png'
  },
  { 
    name: '视频账号运营', 
    path: '/promotion/video-operation',
    colorname: '视频账号',
    shortName: '运营',
    data: [
      '专业团队',
      '创意策划',
      '数据驱动',
      '全案服务'
    ],
    url: '/promotion/header/3.png'
  },
  { 
    name: '媒体宣发', 
    path: '/promotion/media-promotion',
    colorname: '媒体',
    shortName: '宣发',
    data: [
      '对接主流媒体，确保稿件高效发布',
      '资深团队撰写，兼顾规范性与传播力',
      '策划、撰稿、媒体对接，提供全流程支持'
    ],
    url: '/promotion/header/4.png'
  },
  { 
    name: '广告投放', 
    path: '/promotion/advertising',
    colorname: '广告',
    shortName: '投放',
    data: [
      '精准画像建模',
      '实时动态调优',
      '全链路归因分析',
      '提供“策略-执行-优化”一体化的广告投放服务'
    ],
    url: '/promotion/header/5.png'
  },
  { 
    name: '出版服务', 
    path: '/promotion/publishing-service',
    colorname: '出版',
    shortName: '服务',
    data: [
      '深度内容整理',
      '严谨三审三校',
      '匠心视觉设计',
      '高质印制对接'
    ],
    url: '/promotion/header/6.png'
  },
  { 
    name: '品牌视觉设计', 
    path: '/promotion/brand-visual-design',
    colorname: '品牌视觉',
    shortName: '设计',
    data: [
      '品牌视觉全案策划',
      'VI规范系统搭建',
      '多端应用统一延展',
      'IP形象成套输出'
    ],
    url: '/promotion/header/7.png'
  },
  { 
    name: '平面视觉设计', 
    path: '/promotion/graphic-design',
    colorname: '平面',
    shortName: '视觉设计',
    data: [
      '用视觉语言',
      '重构品牌与用户的对话',
    ],
    url: '/promotion/header/8.png'
  },
  { 
    name: '影像类内容制作', 
    path: '/promotion/video-production',
    colorname: '影像',
    shortName: '内容制作',
    data: [
      '活动快剪制作',
      '精品宣传视频',
      '照片直播服务',
      '专业纪实摄影'
    ],
    url: '/promotion/header/9.png'
  },
  { 
    name: '物料制作', 
    path: '/promotion/material-production',
    colorname: '物料',
    shortName: '制作',
    data: [
      '电子杂志制作',
      '宣传画册定制',
      '海报桌牌单页',
      '线下地推物料'
    ],
    url: '/promotion/header/10.png'
  },
  { 
    name: '活动策划执行', 
    path: '/promotion/event-planning',
    colorname: '活动',
    shortName: '策划执行',
    data: [
      '全渠道活动统筹',
      '媒体采风管控',
      '大型活动执行',
      '线上线下联动'
    ],
    url: '/promotion/header/11.png'
  },
  { 
    name: '采编服务', 
    path: '/promotion/editing-service',
    colorname: '采编',
    shortName: '服务',
    data: [
      '专属内容策划',
      '专业化内容采编',
      '标准化输出',
      '资深编辑团队'
    ],
    url: '/promotion/header/12.png'
  }
]
export const developmentTabs = [
  {
    name: '文旅数字化服务',
  },
  {
    name: '内容安全检测',
  },
  {
    name: '数字孪生场景搭建',
  },
  {
    name: '项目管理工具',
  },
  {
    name: '定制化开发服务',
  },
  {
    name: '数字界面设计',
  },
  {
    name: '运营工具',
  }
]
